import React from 'react';
import { Link } from 'react-router-dom';
import Badge from './Badge';
import './ItemList.scss';

interface ItemListProps<T> {
  items: T[];
  linkPrefix: string;
  renderName: (item: T) => string;
  renderStatus: (item: T) => string;
}

const ItemList = <T extends { uuid?: string }>({ items, linkPrefix, renderName, renderStatus }: ItemListProps<T>) => (
  <div className="item-list">
    <ul>
      {items.map(item => (
        <li key={item.uuid} className="item-list-item">
          <Link to={`/${linkPrefix}/${item.uuid}`} className="item-link">
            {renderName(item)}
            <Badge badgeTitle={renderStatus(item)} />
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default ItemList;
